import type { FaireProductEntity } from "../../entity_types/product";

export const p_b464dpjz8n: FaireProductEntity = {
  token: "p_b464dpjz8n",
  type: "product",
  name: "Hot And Flashy Grip Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/b750aca49badf77f001c02204b505485f14f87528b0c1524b87a2aeab3d26b8f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2b8708127f0c59d072a4afe2ade516effece1bc89457be98784bf17847513411.jpeg",
    "https://cdn.faire.com/fastly/4c15f397adbc1f7ac1b431c292789cb1f3e492004f8623e2f4851f076833ad04.jpeg",
    "https://cdn.faire.com/fastly/3a28b577374e3fc9fd4721c050ab4332c3a2654d0225f15e19721eee2eb13ca7.jpeg",
    "https://cdn.faire.com/fastly/a9deebfa246d5528f8bb55686840ed3fe3ef0dc1f92ac7353b88c5ee5a549443.jpeg",
    "https://cdn.faire.com/fastly/757fedcd49a4478f307a38bf92ce7cbb72a8545a6b063854714c88dfb810c6aa.jpeg",
    "https://cdn.faire.com/fastly/f129436108bf84c3ea635d9ea5dd9202284ff49dfa25d07f2f547fb04de6f49a.jpeg",
    "https://cdn.faire.com/fastly/6ef16236b710fb5eec3dc6dce6abe976a22c74c2c34ef5e06387681dc577e8f5.jpeg"
  ],
  priceDollars: 9.6,
  description: "You’re glowing! You're steady! You're slightly at odds with your own thermostat. Look as hot as you feel when you sweat it out in these grip socks.\n\nFinally! Grip socks that do a better job and look good doing it. 🤩\n\n• Woven-in premium grip yarn that holds up use after use. No glued-on dots. \n• Knit into the heel and toe, not just the sole, for better stability. \n• Built for Pilates, barre, yoga, and every stretch in between. \n• Bold, funny, and unreasonably well made in the USA!\n\n#pilatessocks #gripsocks #grippysocks #barresocks #yogasocks #grippy #lagreesocks #pilates #barre #lagree #yoga #grip\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:33:19.472Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
